"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLASpanAdaptor = exports.SpanSubFormAdaptor = void 0;
const core_api_1 = require("@ikegps/core-api");
const integrations_1 = require("./integrations");
/**
 * SpanSubFormAdaptor wraps a SubForm instance whose SubForm type has been set to SPAN.
 * The SubForm instance is then mapped to the ISpan interface.
 */
class SpanSubFormAdaptor {
    /**
     * @throws The constructor throws an Error if the instance passed into the constructor is not for a Span SubForm.
     * Be sure to check this condition before instantiating SpanSubFormAdaptor.
     */
    constructor(instance) {
        this.instance = instance;
        if (instance.schema.subFormType !== core_api_1.SubFormType.SPAN) {
            throw new Error("SubForm instance's schema must have type SPAN to be passed into SpanSubFormAdaptor");
        }
        if (!instance.schema.subFormSpanTypeState) {
            throw new Error("SubForm instance's schema is type SPAN but is missing the SubFormSpanTypeState");
        }
        this.subFormSpanTypeState = instance.schema.subFormSpanTypeState;
    }
    get spanVectorField() {
        return this.instance.getField(this.subFormSpanTypeState.vectorFieldId);
    }
    get spanTypeField() {
        return this.instance.getField(this.subFormSpanTypeState.typeFieldId);
    }
    get spanType() {
        switch (this.spanTypeField.value) {
            case integrations_1.IPFSpanType.FORE_SPAN:
            case integrations_1.SpanType.NextPole:
                return integrations_1.SpanType.NextPole;
            case integrations_1.IPFSpanType.BACK_SPAN:
            case integrations_1.SpanType.PreviousPole:
                return integrations_1.SpanType.PreviousPole;
            case integrations_1.IPFSpanType.OTHER:
            case integrations_1.SpanType.Other:
                return integrations_1.SpanType.Other;
            default:
                return null;
        }
    }
    get spanVector() {
        return this.spanVectorField.value;
    }
    get spanTargetCollectionId() {
        var _a, _b;
        if (!this.spanVectorField.isCollectionLink()) {
            return null;
        }
        return (_b = (_a = this.spanVectorField.stateValue) === null || _a === void 0 ? void 0 : _a.collectionId) !== null && _b !== void 0 ? _b : null;
    }
    get spanMidSpanIkePhotoField() {
        if (!this.subFormSpanTypeState.midSpanIkePhotoFieldId) {
            return null;
        }
        return this.instance.getField(this.subFormSpanTypeState.midSpanIkePhotoFieldId);
    }
    get midSpanIkePhotos() {
        var _a, _b;
        return (_b = (_a = this.spanMidSpanIkePhotoField) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : [];
    }
}
exports.SpanSubFormAdaptor = SpanSubFormAdaptor;
/**
 * PLASpanAdaptor wraps a SubForm instance from the Span field of any PLAForm compatible form.
 * The SubForm instance is then mapped to the ISpan interface.
 */
class PLASpanAdaptor {
    /**
     * @throws The constructor throws an Error if the SubForm instance passed into the
     * constructor is not for the Span field of the given PLAForm.
     * Be sure to check this condition before instantiating SpanSubFormAdaptor.
     */
    constructor(instance, form) {
        this.instance = instance;
        this.form = form;
        if (instance.schema.id !== form.spanField.id) {
            throw new Error("SubForm instance's schema must be the SPAN field of the given PLA form");
        }
    }
    get spanTypeField() {
        return this.instance.getField(this.form.spanTypeField.id);
    }
    get spanVectorField() {
        return this.instance.getField(this.form.spanVectorField.id);
    }
    get spanType() {
        switch (this.spanTypeField.value) {
            case integrations_1.IPFSpanType.FORE_SPAN:
            case integrations_1.SpanType.NextPole:
                return integrations_1.SpanType.NextPole;
            case integrations_1.IPFSpanType.BACK_SPAN:
            case integrations_1.SpanType.PreviousPole:
                return integrations_1.SpanType.PreviousPole;
            case integrations_1.IPFSpanType.OTHER:
            case integrations_1.SpanType.Other:
                return integrations_1.SpanType.Other;
            default:
                return null;
        }
    }
    get spanVector() {
        return this.spanVectorField.value;
    }
    get spanTargetCollectionId() {
        var _a, _b;
        if (!this.spanVectorField.isCollectionLink()) {
            return null;
        }
        return (_b = (_a = this.spanVectorField.stateValue) === null || _a === void 0 ? void 0 : _a.collectionId) !== null && _b !== void 0 ? _b : null;
    }
    get spanMidSpanIkePhotoField() {
        const midSpanPhotoFormField = this.form.spanMidSpanIkePhoto;
        if (!midSpanPhotoFormField) {
            return null;
        }
        return this.instance.getField(midSpanPhotoFormField.id);
    }
    get midSpanIkePhotos() {
        var _a, _b;
        return (_b = (_a = this.spanMidSpanIkePhotoField) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : [];
    }
}
exports.PLASpanAdaptor = PLASpanAdaptor;
//# sourceMappingURL=ISpan.js.map